import { IPackageSearchResultData } from '../../../types';

// TODO: WTF @@renji bro 😭
// TODO: @renji revise this whole component and fix most of this duplicate logic...
// I have tried to rename the variables to avoid the duplicate logic but it's still messed up..
// Why not write a simple function to avoid all this boilerplate repeatetion.
export function formatSearchPackageResponse(
  raw: IPackageSearchResultData
): IPackageSearchResultData {
  const { multiLocationInventories, inventories } = raw;

  const formattedInventories = inventories?.map((inventory) => {
    const {
      _id,
      appraisalCode,
      assetId,
      assetName,
      imeiOrSerialNumber,
      podName,
      trayNumber,
      podType,
      awbNumber,
      barCode,
    } = inventory;

    return {
      _id,
      appraisalCode: appraisalCode || 'none',
      assetId: assetId || 'none',
      assetName: assetName || 'none',
      imeiOrSerialNumber: imeiOrSerialNumber || 'none',
      podName: podName || 'none',
      trayNumber: trayNumber || 'none',
      podType: podType || 'none',
      awbNumber: awbNumber || 'none',
      barCode: barCode || 'none',
    };
  });

  const formattedMultiLocationInventories = multiLocationInventories?.map(
    (multiLocationInventory) => {
      const {
        location,
        inventories: inventoriesItems,
        total,
      } = multiLocationInventory;

      const formattedInventoriesItems = inventoriesItems.map((inventory) => {
        const {
          _id,
          appraisalCode,
          assetId,
          assetName,
          imeiOrSerialNumber,
          podName,
          trayNumber,
          podType,
          awbNumber,
          barCode,
        } = inventory;

        return {
          _id,
          appraisalCode: appraisalCode || 'none',
          assetId: assetId || 'none',
          assetName: assetName || 'none',
          imeiOrSerialNumber: imeiOrSerialNumber || 'none',
          podName: podName || 'none',
          trayNumber: trayNumber || 'none',
          podType: podType || 'none',
          awbNumber: awbNumber || 'none',
          barCode: barCode || 'none',
        };
      });

      return {
        location,
        inventories: formattedInventoriesItems,
        total,
      };
    }
  );

  return {
    isMultipleLocation: raw.isMultipleLocation,
    multiLocationInventories: formattedMultiLocationInventories,
    inventories: formattedInventories,
    total: raw.total,
  };
}
